<template>
  <div class="admin-layout">
    <header class="admin-layout__header">
      <div class="header__logo">
        <span class="logo-icon">⚙️</span>
        <span class="logo-text">FormIQ Admin</span>
      </div>
      <button class="dashboard-btn" @click="goToDashboard">← Zum Dashboard</button>
    </header>

    <div class="admin-layout__body">
      <nav class="admin-sidebar">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="sidebar-link"
          :class="{ 'sidebar-link--active': isActive(item.path) }"
        >
          <span class="sidebar-link__icon">{{ item.icon }}</span>
          <span class="sidebar-link__label">{{ item.label }}</span>
        </router-link>
      </nav>

      <main class="admin-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';

const NAV_ITEMS = [
  // { path: '/admin/workflows', label: 'Workflows', icon: '📋' },
  { path: '/admin/formiq3', label: 'FormIQ3', icon: '🌳' },
];

export default {
  name: 'AdminLayout',

  setup() {
    const route = useRoute();
    const router = useRouter();

    const isActive = (path) => route.path.startsWith(path);
    const goToDashboard = () => router.push('/dashboard');

    return { navItems: NAV_ITEMS, isActive, goToDashboard };
  },
};
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f2f8;
}

.admin-layout__header {
  background: #ffffff;
  border-bottom: 3px solid #c0121c;
  padding: 14px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.header__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}
.logo-icon { font-size: 20px; }

.dashboard-btn {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #0f172a;
  padding: 7px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.dashboard-btn:hover { background: #e2e8f0; }

.admin-layout__body {
  flex: 1;
  display: flex;
  min-height: 0;
}

.admin-sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #ffffff;
  border-right: 1px solid #d0d7de;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.sidebar-link:hover { background: #f1f5f9; }
.sidebar-link--active {
  background: #fdecec;
  color: #c0121c;
}
.sidebar-link__icon { font-size: 16px; }

.admin-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
</style>
